import React, { useEffect, useState } from 'react';
import { Box, Flex, Grid, Text } from '@chakra-ui/react';
import { colors } from '../../../utils/colors';
import { ProgressBreakpoint } from './ProgressBreakpoint/progressBreakpoint';
import { Flag } from '../../../utils/icons/flag';
import { useTranslation } from 'react-i18next';
import { ContentContainer } from '../ContentContainer/contentContainer';

export const ProgressBar = ({ currentStep, maxSteps }: { currentStep: number; maxSteps: number }) => {
	const { t } = useTranslation();
	const [progress, setProgress] = useState(0);

	useEffect(() => {
		setProgress(Math.ceil((currentStep / maxSteps) * 100));
	}, [currentStep]);

	const newProgress = () => {
		if (progress <= 86) {
			const newProgress = progress + 8;
			setProgress(newProgress);
		} else {
			setProgress(100);
		}
	};

	return (
		<ContentContainer noPadding>
			<Grid
				w="100%"
				m="60px 0px 40px 0px"
			>
				<Flex
					gridGap="10px"
					flexDirection="column"
					pb="12px"
					w="100%"
					position="relative"
				>
					<Flex
						justifyContent="space-between"
						alignItems="center"
						pb="4px"
					>
						<Flex marginLeft={`${progress === 100 ? 97 : progress}%`}>
							<Text
								fontWeight="500"
								color={colors.primary}
								fontSize="11px"
								lineHeight="160%"
								letterSpacing="0.3em"
							>
								{progress}%
							</Text>
						</Flex>
						{progress == 100 ? null : <Flag />}
					</Flex>
					<Flex
						alignItems="center"
						w="100%"
					>
						<Box
							w="100%"
							h="8px"
							position="absolute"
							background={`repeating-linear-gradient(to right, ${colors.graySecondary} 0px, ${colors.graySecondary} 2px, transparent 2px, transparent 6px)`}
						/>
						<ProgressBreakpoint />
						<Box
							w={`${progress}%`}
							h="8px"
							transition="0.5s width"
							maxWidth="1240px"
							bgColor={colors.primary}
							position="absolute"
						/>
						<Box
							paddingLeft={`${progress}%`}
							h="8px"
							transition="0.5s padding"
							maxWidth="1240px"
							bgColor={colors.primary}
							position="absolute"
							filter="blur(6px)"
						/>
					</Flex>
					<Flex
						justifyContent="space-between"
						w="100%"
					>
						<Text
							pt="16px"
							fontSize="11px"
							lineHeight="160%"
							color="#8C8C8C"
							letterSpacing="0.3rem"
						>
							{t('progressBar.progress').toUpperCase()}
						</Text>
						<Text
							pt="16px"
							fontSize="11px"
							lineHeight="160%"
							color="#8C8C8C"
							letterSpacing="0.3rem"
							cursor="pointer"
							onClick={newProgress}
						>
							{t('progressBar.final').toUpperCase()}
						</Text>
					</Flex>
				</Flex>
			</Grid>
		</ContentContainer>
	);
};
